module.exports = __webpack_public_path__ + "img/icon_xx3.2ee1a72.png";